export default "__VITE_ASSET__DvHriZa6__"